import * as React from "react";
import { Button, Margin, P, SuccessNotification } from "@ovotech/element";

export const AlreadySubmittedPageContent = () => (
  <>
    <SuccessNotification
      id="already-submitted-error"
      title="Looks like you’ve been here before"
      style={{ marginBottom: "4rem" }}
    >
      <P>
        Looks like you’ve already started an application for a charger with OVO
        Energy. Rather than make you start again, we will re-send you the email
        with the link to your onboarding survey.
      </P>
    </SuccessNotification>

    <Margin top={8} />
    <Button variant="surface" data-testid="resend-button">
      Resend me the email with the survey link
    </Button>
  </>
);
